import React from 'react';
import useStore from 'state/state';
import { bool } from 'prop-types';
import CloseIcon from 'assets/images/icons/close.svg';
import OnboardingSlideshow from 'components/OnboardingSlideshow/OnboardingSlideshow';
import { useSpring, animated } from 'react-spring';

import styles from './Onboarding.module.scss';

const Onboarding = ({ intro, loadingComplete }) => {
  const setIsOnboardingOpen = useStore((state) => state.setIsOnboardingOpen);
  const props = useSpring({ to: { opacity: 1 }, from: { opacity: 0 } });
  const close = () => {
    setIsOnboardingOpen(false);
  };
  return (
    <animated.div style={props}>
      <div className={styles.wrapper}>
        <button
          type="button"
          className={styles.tint}
          label="tint"
          onClick={close}
        />
        <div className={styles.content}>
          <button
            label="close"
            type="button"
            onClick={close}
            className={styles.close}
          >
            <CloseIcon />
          </button>
          <OnboardingSlideshow
            intro={intro}
            loadingComplete={loadingComplete}
          />
        </div>
      </div>
    </animated.div>
  );
};
Onboarding.propTypes = {
  intro: bool,
  loadingComplete: bool,
};

Onboarding.defaultProps = {
  intro: false,
  loadingComplete: false,
};

export default Onboarding;
